import { useState } from "react"
import { post } from "../../api/api"

export default function KeywordGap() {
  const [domain, setDomain] = useState("")
  const [competitor, setCompetitor] = useState("")
  const [result, setResult] = useState(null)

  async function runGap() {
    const res = await post("/keyword-gap", { domain, competitor })
    setResult(res.data)
  }

  return (
    <div className="page">
      <h1>Keyword Gap</h1>
      <div className="card form-row">
        <label>
          Your domain
          <input value={domain} onChange={(e) => setDomain(e.target.value)} />
        </label>
        <label>
          Competitor domain
          <input value={competitor} onChange={(e) => setCompetitor(e.target.value)} />
        </label>
        <button onClick={runGap}>Compare</button>
      </div>
      {result && (
        <div className="card">
          <p className="muted">{result.message}</p>
          <pre>{JSON.stringify(result.missingKeywords || [], null, 2)}</pre>
        </div>
      )}
    </div>
  )
}
